import React from 'react';
import PropTypes from 'prop-types';
import Application from 'hellosign/detached-application';

const contextValueType = PropTypes.shape({
  /**
   * Application instance
   */
  app: PropTypes.instanceOf(Application),

  csrfToken: PropTypes.string.isRequired,

  /**
   * Indicates either HelloSign or HelloFax.
   */
  siteCode: PropTypes.oneOf(['S', 'F']).isRequired,

  signature: PropTypes.shape({

    /**
     * Indicates a type of either "signature" or "initial."  Used in the
     * signature modal
     */
    type: PropTypes.oneOf(['S', 'I']).isRequired,
  }),

  /**
   * Properties of the currently logged-in user.
   */
  user: PropTypes.shape({
    emailAddress: PropTypes.string.isRequired,
    id: PropTypes.number.isRequired,
    isFree: PropTypes.bool,
    name: PropTypes.string.isRequired,
    numApiDocsLeft: PropTypes.number,
    numDocsLeft: PropTypes.number,
    numTemplatesLeft: PropTypes.number,
    primarySignatureGuid: PropTypes.string,
    settings: PropTypes.shape({
      firstName: PropTypes.string,
      lastName: PropTypes.string,
    }),
    showApiCredits: PropTypes.bool,
  }),

  isSpa: PropTypes.bool,
  featureFlags: PropTypes.object,
  termsURL: PropTypes.string.isRequired,
  privacyURL: PropTypes.string.isRequired,
});

// Everything the layout needs is injected to the `<Root`, but that component
// needs to handle routing, then each page decides whether or not to use the
// <DefaultLayout. Instead of having to pass the props down, `<Root` will just
// inject the data into the context so that each route can just render
// `<DefaultLayout>{content}`
export const DefaultLayoutContext = React.createContext(undefined);

export const DefaultLayoutConsumer = DefaultLayoutContext.Consumer;

export function DefaultLayoutProvider({ value, children }) {
  return (
    <DefaultLayoutContext.Provider value={value}>
      {children}
    </DefaultLayoutContext.Provider>
  );
}

DefaultLayoutProvider.propTypes = {
  value: contextValueType,
  children: PropTypes.node.isRequired,
};
